<template>
  <div v-if="options !== null && options !== undefined">
    <pbas-data-table
      v-if="provider"
      :exporters="$exporters"
      ref="table"
      class="table-balances"
      :dataProvider="provider"
      fileNamePrefix="member-balance-history"
      :identifier="'member_balance_table' + selectedPlan.Id"
      :expandedRowActions="expandedRowActions"
      :expandedFloatActions="() => []"
      @error="error = $event"
      @expanded-changed="setData($event)"
      :show-select="false"
      :canExpand="(item) => true"
      :showExpand="true"
      :generateProviderForExpanded="(item) => generateProvider(item)"
      :expandedSortBy="'EffectiveDate'"
      :expandedSortDescending="true"
      :floatActions="floatActions"
    ></pbas-data-table>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="loading" scrollable max-width="100px" persistent>
      <v-container fluid grid-list-md>
        <v-layout row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <add-edit-credit-dialog
      :isNew="isNew"
      :memberIdentity="memberIdentity"
      :model="addEditCredit"
      :credit="editedItem"
      :credits="credits"
      @close="addEditCredit = false; editedItem = null"
      @save="
        addEditCredit = false;
        editedItem = null;
        reload();
      "
    />
    <v-dialog
      v-model="deleteCreditDialog"
      persistent
      max-width="400"
      scrollable
    >
      <material-card
        :title="$t('components.delete_credit_dialog.title')"
        icon="delete"
        :color="$vuetify.theme.themes.light.error"
        v-if="deleteCreditDialog"
      >
        <v-card-text>
          {{ $t("components.delete_credit_dialog.text_{0}_{1}", [formatter.format(editedItem.Amount), editedItem.Year]) }}
          <v-form ref="form" v-model="valid">
            <div class="col-12">
              <v-textarea
                :label="$t('globals.reason')"
                clearable
                auto-grow
                rows="1"
                counter
                v-model="editedItem.Reason"
                class="required"
                :rules="[$rules.required]"
              ></v-textarea>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="deleteCreditDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="deleting"
            color="error"
            @click="tryDeleteCredit()"
          >
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import BalanceHistoryHeaders from "@/headers/MemberBalanceHistory";
import getHistoryTransactionsHeaders from "@/headers/MemberHistoryTransactions";
import ErrorHandler from "@/components/ErrorHandler";
import AddEditCreditDialog from "@/components/AddEditCreditDialog.vue";

export default {
  props: ["memberIdentity"],
  components: {
    ErrorHandler,
    AddEditCreditDialog,
  },
  data() {
    return {
      loading: false,
      valid: false,
      deleting: false,
      provider: null,
      error: null,
      editedItem: null,
      isNew: false,
      credits: {},
      floatActions: [
        {
          text: "components.add_credit_dialog.add_credit",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: () => {
            this.editedItem = {};
            this.isNew = true;
            this.addEditCredit = true;
          },
        },
      ],
      formatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      }),
      deleteCreditDialog: false,
      addEditCredit: false,
      expandedRowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            console.log("item to edit",item);
            this.isNew = false;
            this.editedItem = JSON.parse(JSON.stringify(item));
            this.editedItem.Reason = "";
            this.addEditCredit = true;
          },
          visible: (item) => {
            if (
              item.Type === "Forfeit" ||
              item.Type === "Deduction" ||
              item.Type === "Reserved"
            ) {
              // value = -Math.abs(item.Amount);
              return false;
            }
            return true;
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.editedItem = JSON.parse(JSON.stringify(item));
            this.deleteCreditDialog = true;
          },
          visible: (item) => {
            if (
              item.Type === "Forfeit" ||
              item.Type === "Deduction" ||
              item.Type === "Reserved"
            ) {
              // value = -Math.abs(item.Amount);
              return false;
            }
            return item.Amount <= item.ParentAmount;
          },
        },
      ],
    };
  },
  methods: {
    ...mapActions("claims", ["deleteMemberCredit"]),
    async loadData() {
      const headers = BalanceHistoryHeaders;
      if (this.memberIdentity.Id) {
        const url = `/plans/${this.selectedPlan.Id}/members/${
          this.memberIdentity.Id
        }/balance-history`;
        this.provider = new ODataProvider(this.$axiosHttp, url, headers);
      }
    },
    generateProvider(item) {
      const url =
        "plans/" +
        this.selectedPlan.Id +
        "/members/" +
        this.memberIdentity.Id +
        "/transactions";
      let p = new ODataProvider(
        this.$axiosHttp,
        url,
        getHistoryTransactionsHeaders(this.options.Enums)
      );
      p.filter = `HSACreditId eq ${item.Id}`;
      return p;
    },
    setData(data) {
      console.log("setData items", data);
      if (data.items.length > 0) {
        data.items.forEach((item) => {
          item.Year = data.parent.Year;
          item.ParentId = data.parent.Id;
          item.ParentAmount = data.parent.Amount;
          this.credits[item.Id] = item;
        });
      }
    },
    reload() {
      this.$refs.table.getDataAsync();
      this.$emit("reload");
    },
    async tryDeleteCredit() {
      try {
        this.deleting = true;
        this.error = null;
        await this.deleteMemberCredit({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentity.Id,
          creditId: this.editedItem.Id,
          payload: {
            Reason: this.editedItem.Reason,
          },
        });
        this.deleteCreditDialog = false;
        this.color = "success";
        this.message = "globals.success";
        this.editedItem = {};
        this.reload();
      } catch (error) {
        console.log("delete error", error);
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 3010
        ) {
          console.log("delete error data", error.response.data.Message);
          this.error = {
            customMessage: this.$t("components.delete_credit_dialog.error"),
          }
        }
      }
      finally {
        this.deleting = false;
      }
    },
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["role"]),
  },
  watch: {
    memberIdentity: {
      handler: function() {
        if (this.provider === null || this.provider === undefined) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    if (this.memberIdentity !== null && this.memberIdentity !== undefined) {
      this.loadData();
    }
  },
};
</script>
<style scoped>
.table-balances >>> .v-data-table__expanded.v-data-table__expanded__row {
  line-height: 1.6;
}
</style>
